<template>
    <div class="homepage-video-player-container">
        <youtube class="video-modal-player-container" :video-id="videoId" :player-vars="{ autoplay: 1 }"></youtube>
        <div class="homepage-video-buttons">
            <div class="home-full-width-video-cta">
                <a :href="settings.socialLinks.whatsapp" target="_blank" @click="joinWhatsapp()">
                    <button class="button-cta"><span class="play-icon"><img src="/assets/img/logo-whatsapp.png" /></span>Join MommyDeals</button>
                </a>
                <button class="button button-get-started" @click="stopVideo()">Close</button>
            </div>
            
        </div>
    </div>
</template>

<script>
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import EventBus from '@/helpers/event-bus'
    export default {
        data() {
            return {
                showVideoModal: false,
                videoId: 'gSM0FGKIDSY'
            }
        },
        created() {

        },
        computed: {
            settings: function () { return settings; }
        },
        methods: {
            stopVideo() {
                EventBus.$emit('stopHomepageVideo');
            },
            joinWhatsapp() {
                ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
                clicky.goal("JoinWhatsAppHomepageVideo2")
            }
        }
    }
</script>